import type { Testkit, UniDriver } from 'ricos-types/testkit';
import { dataHook } from 'wix-rich-content-common';

import { ITALIC_BUTTON_DATA_HOOK } from './data-hooks';

export type ItalicTestkit = Testkit<{
  content: object;
  toolbars: {
    createTextButtonToolbars: (getTextButtonToolbarBase: () => UniDriver<Element>) => {
      click: () => Promise<void>;
      getElement: () => Promise<UniDriver<Element>>;
    };
  };
}>;

export const createItalicTestkit: ItalicTestkit = () => {
  return {
    content: {},
    toolbars: {
      createTextButtonToolbars: (getTextButtonToolbarBase: () => UniDriver<Element>) => ({
        click: async () => {
          const button = getTextButtonToolbarBase().$(dataHook(ITALIC_BUTTON_DATA_HOOK));
          await button.click();
        },
        getElement: () => getTextButtonToolbarBase().get(dataHook(ITALIC_BUTTON_DATA_HOOK)),
      }),
    },
  };
};
